// Copyright (c) 2022 by Move Closer

import { CanHaveCustomClass, Module, ModuleContent, ModuleSourceOptions, ProductData, Related } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'
import { HeadingFormData } from '../partials'

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export type ProductsUpsellModule = Module<ProductsUpsellModuleContent, AvailableModuleDriver.ProductsUpsell>

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export interface ProductsUpsellModuleData extends CanHaveCustomClass {
  /**
   * Determines products amount
   */
  count: number

  hasCart?: boolean

  /**
   * Determines products upsell heading
   */
  heading?: HeadingFormData

  /**
   * Determines products to render
   */
  products: ProductData[] | null

  /**
   * Determines products amount at carousel page
   */
  productsPerPage: number

  /**
   * Determines promo title
   */
  promoTitle: string

  /**
   * Should enable product promo
   */
  enableProductPromo: boolean

  /**
   * Determines product sku
   */
  productSku: string

  /**
   * Determines required amount of product to achieve the promo
   */
  requiredProductQuantity: string

  /**
   * Should enable cart promo
   */
  enableCartPromo: boolean

  /**
   * Determines minimum net total to achieve the promo
   */
  requiredCartTotalPromo: string
}

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export type ProductsUpsellModuleContent = ProductsUpsellModuleData & ModuleContent

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export interface ProductsUpsellModuleContentInput extends Omit<ProductsUpsellModuleData, 'products'>, ModuleContent {
  sku: string | null
  filters: Related[] | null
  products: Related
}

export interface ProductsUpsellSourceOptions extends ModuleSourceOptions {
  mode: string
  sku?: boolean
}

export interface ProductsUpsellSourceConfigurationOptions {
  modeOptions: string[]
}

export enum ProductUpsellSourceMode {
  Brand = 'brand',
  Category = 'category',
  BrandAndCategory = 'brandAndCategory',
  Line = 'line',
  Filters = 'filters'
}
